<template lang="pug">
  .feature-blocker
    AlertBox(type="info", v-if="feature.block", :text="feature.message")

    .blocker-container
      .blocker(v-if="feature.block")
      .blocked-feature
        slot
</template>

<script>

export default {
  name: 'HasAccess',
  props: {
    allowance: String
  },
  data () {
    return {
      feature: this.$allowed(this.allowance)
    }
  },

  computed: {
    text () {
      return ''
    }
  }

}
</script>

<style scoped lang="stylus">
.blocker-container
  position relative
  .blocker
    background-color rgba(255,255,255,.5)
    position absolute
    top 0
    left 0
    height 100%
    width 100%
    z-index 1
  .blocked-feature
    position relative
    z-index 0
</style>
